import i18next from "@/i18n";

/**
 * The app's error screen; its button full-reloads, which is also the only retry that clears a stale route chunk.
 * Copy comes from `i18next.t` rather than the hook because the class-based ErrorBoundary renders it too.
 */
export function ErrorFallbackContent() {
	return (
		<div className="flex flex-col items-center justify-center min-h-[50vh] text-center px-4">
			<h1 className="subheading-2 mb-4">{i18next.t("modal.Oops! Something went wrong")}</h1>
			<p className="body-reg text-dark-grey mb-8">
				{i18next.t("modal.Please try again as an unexpected error occurred!")}
			</p>
			<button
				className="px-6 py-2 bg-dark text-light rounded"
				onClick={() => window.location.reload()}
			>
				{i18next.t("buttons.Try again")}
			</button>
		</div>
	);
}
